import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { formatDate, formatDateTime, TIME_ZONE } from 'helpers/dateTimeFormatter';
import './styles.scss';

const DriveStatusChartToolTipComponent = ({ timeStamp, value, isUTC, showTimePortion }) => {
    const style1 = {
        backgroundColor: value?.color,
    };
    return <div className='custom-drive-chart-tooltip'>
        <div className='t-header'>
            {isUTC
                ? `${formatDateTime(timeStamp, { timeZone: TIME_ZONE.UTC })} (${translate('ABB.Powertrain.Frontend.UTC')})`
                : showTimePortion ? formatDateTime(timeStamp) : formatDate(timeStamp)}
        </div>
        <br />
        <div className='t-item'>
            <span className='symbol' style={style1} />
            <span>{`${translate('ABB.Powertrain.Frontend.conditionDriveStatusLabel')} ${translate(value?.label)}`}</span>
        </div>
    </div>;

};
export default DriveStatusChartToolTipComponent;

DriveStatusChartToolTipComponent.propTypes = {
    timeStamp: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.instanceOf(Date)
    ]),
    value: PropTypes.shape({
        color: PropTypes.string,
        label: PropTypes.string,
    }),
    isUTC: PropTypes.bool, // Added validation for isUTC
    showTimePortion: PropTypes.bool,
};
